import styled from "styled-components";

export const HEADER_HEIGHT = 64;
export const HEADER_HEIGHT_MOBILE = 64;

export const HeaderColumn = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: center;
  height: 100%;
  box-sizing: border-box;
`;

export const MainContainer = styled.main`
  grid-area: main;
  overflow: auto;
  background-color: var(--sinch-sys-color-container-contrast-primary-default);
`;
